import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONFIG } from '../interceptors/loader.interceptor';
import { HttpContextConfig } from '../models/http-context-config';

const calendarApi = `${environment.api}/calendar/`;

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  constructor(private readonly http: HttpClient) {}

  getActiveUsers(calendarArea?: string) {
    const params = calendarArea
      ? new HttpParams().set('calendar_area', calendarArea)
      : undefined;

    return this.http.get<any>(calendarApi + 'getActiveUsers', { params });
  }

  getCalendarUsers(
    startOfWeek: string,
    search: any[] | null,
    teams: number[],
    roles: number[],
    events: number[],
    isSmartOnly?: boolean,
    calendarArea?: string
  ) {
    return this.http.post<any>(calendarApi + 'index', {
      selected_users: search,
      startweek_date: startOfWeek,
      teams_id: teams,
      roles_id: roles,
      events: events,
      isSmartOnly: isSmartOnly,
      calendar_area: calendarArea
    });
  }

  // funzione per salvare una nuova review
  storeReviewRequest(request: any) {
    return this.http.post<any>(calendarApi + 'storeReviewRequest', request);
  }

  updateReviewRequest(request: any, request_id: number) {
    return this.http.put<any>(
      calendarApi + 'updateReviewRequest/' + request_id,
      request
    );
  }

  deleteEventRequest(id: string) {
    return this.http.delete<any>(`${calendarApi}deleteEventRequest`, {
      params: { event_id: id }
    });
  }

  // Accetto o rifiuto le richieste degli utenti
  manageUserRequest(request: any) {
    return this.http.patch<any>(calendarApi + 'manageUserRequest', request);
  }

  //funzione per recuperare tutte le sale
  getAllRooms() {
    return this.http.get<any>(calendarApi + 'getAllRooms');
  }

  getUserCalendar(userId: string, data?: string) {
    return this.http.post<any>(calendarApi + 'getUserEvents', {
      userId: userId,
      date: data
    });
  }

  getUserEventDates(startDate: string, userId?: string | number) {
    let params = new HttpParams().set('startDate', startDate);
    if (userId != null) {
      params = params.set('userId', String(userId));
    }
    return this.http.get<any>(`${calendarApi}userEventDates`, { params });
  }

  /**
   * Metodo che chiama l'API per pubblicare o salvare gli eventi modificati/generati
   * @param startDate prima data visibile nel calendario
   * @param endDate ultima data visibile nel calendario
   * @param firstDateCurrentMonth prima data del mese attuale
   */
  confirmEventsOrPublishCalendar(startDate: string, endDate: string) {
    const paramToSend = {
      start_date: startDate,
      end_date: endDate
    };
    return this.http.post<any>(calendarApi + 'confirmDraftEvents', paramToSend);
  }

  getNotifications(
    referenceDate: string,
    calendarArea?: string
  ): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    let queryParams = new HttpParams().set('referenceDate', referenceDate);
    if (calendarArea) {
      queryParams = queryParams.set('calendar_area', calendarArea);
    }

    return this.http.get<any>(`${calendarApi}eventCounters`, {
      context,
      params: queryParams
    });
  }

  /**
   * Metodo che serve per capire se l'utente loggato ha delle malattie in corso,
   * Viene utilizzata nella sidebar per effettuare la 'Malatttia rapida' senza dover
   * passare per la sezione 'Calendario'
   */
  getPendingIllnessForLoggedUser() {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    const context = new HttpContext().set(CONFIG, config);
    return this.http.get<any>(`${calendarApi}getPendingIllnessForLoggedUser`, {
      context
    });
  }
}
